import React from "react";

export default function Line() {
  return (
    <div
      style={{
        width: "1px",
        height: "36px",
        margin: "0 49px 0.5px 30px",
        backgroundColor: "#ccd6e5",
      }}
    ></div>
  );
}
